import React, { useEffect, useState } from 'react'
import Layout from './Layout'
import useApiUrlTranslation from './useApiUrlTranslation'
import Loader from './Loader'

const FORM_ROUTE = 'game-changer'
const FORM_ID = 58

const FormulairesPlanaction = () => {
    const [cycleLangList, setCycleLangList] = useState(null)
    const { i18n, apiUrlTranslation } = useApiUrlTranslation()

    useEffect(() => {
        const fetchPlans = async () => {
            const res = await fetch(
                `${apiUrlTranslation}?action=getCycleLang&filter=cycle_lang_type IN('collectif_planaction') AND cycle_lang_state='active' AND &get_parents=0&get_children=0`
            )
            const data = await res.json()
            setCycleLangList(data.sort((a, b) => a.nom_cycle_lang.localeCompare(b.nom_cycle_lang)))
        }
        fetchPlans()
    }, [i18n.resolvedLanguage, apiUrlTranslation])

    const buildFormUrl = (id_cycle_lang) => {
        const lng = i18n.resolvedLanguage || 'fr'
        const base = 'https://www.myglobalvillage.com'
        return `${base}/signup/${FORM_ROUTE}/?form-name=${FORM_ROUTE}&formisvisible=1&id_formulaire=${FORM_ID}&lng=${lng}&id_cycle_lang_preselection_list=${id_cycle_lang}`
    }

    return (
        <Layout>
            <div className="max-w-6xl mx-auto px-4 py-10">
                <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">
                    Prioritaire : Positionnement par verticale
                </h1>
                <p className="text-gray-600 dark:text-neutral-400 mb-8 text-sm leading-relaxed max-w-3xl">
                    Quel que soit l'événement auquel vous allez participer, remplissez en priorité les formulaires
                    correspondant à vos univers d'action ci-dessous. Au delà de votre présence événementielle
                    myGlobalVillage vous associera dans les 3 prochains mois à la cohorte des solutions
                    sectorielles présentées lors de webcast.
                </p>

                {!cycleLangList && <Loader />}

                {cycleLangList && (
                    <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-neutral-700 shadow-sm">
                        <table className="w-full border-collapse text-sm">
                            <thead>
                                <tr className="bg-gray-50 dark:bg-neutral-800">
                                    <th className="border-b border-r border-gray-200 dark:border-neutral-700 p-3 w-24"></th>
                                    <th className="border-b border-r border-gray-200 dark:border-neutral-700 p-3 text-left font-semibold text-gray-700 dark:text-neutral-200 uppercase text-xs tracking-wide">
                                        Votre secteur majeur
                                    </th>
                                    <th className="border-b border-r border-gray-200 dark:border-neutral-700 p-3 text-left font-semibold text-gray-700 dark:text-neutral-200 uppercase text-xs tracking-wide">
                                        Diagnostic export et formulaire à remplir
                                    </th>
                                    <th className="border-b border-gray-200 dark:border-neutral-700 p-3 text-left font-semibold text-gray-700 dark:text-neutral-200 uppercase text-xs tracking-wide">
                                        Si vous êtes dispo ?
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {cycleLangList.map((cycleLang, index) => (
                                    <tr
                                        key={cycleLang.id_cycle_lang}
                                        className={`border-b border-gray-100 dark:border-neutral-800 transition-colors hover:bg-gray-50 dark:hover:bg-neutral-700 ${index % 2 === 0 ? 'dark:bg-neutral-900' : 'bg-gray-50/50 dark:bg-neutral-800'}`}
                                    >
                                        <td className="border-r border-gray-100 dark:border-neutral-800 p-2 text-center">
                                            {cycleLang.logo_better?.small && (
                                                <img
                                                    src={cycleLang.logo_better.small}
                                                    alt={cycleLang.nom_cycle_lang}
                                                    className="w-20 h-20 object-contain mx-auto"
                                                />
                                            )}
                                        </td>
                                        <td className="border-r border-gray-100 dark:border-neutral-800 p-4 font-bold text-gray-800 dark:text-white uppercase text-sm leading-snug">
                                            {cycleLang.nom_cycle_lang}
                                        </td>
                                        <td className="border-r border-gray-100 dark:border-neutral-800 p-4">
                                            <a
                                                href={buildFormUrl(cycleLang.id_cycle_lang)}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-e2o-500 hover:text-e2o-600 hover:underline break-all text-xs leading-relaxed"
                                            >
                                                {buildFormUrl(cycleLang.id_cycle_lang)}
                                            </a>
                                        </td>
                                        <td className="p-4 text-gray-600 dark:text-neutral-400 text-sm">
                                            Briefing d'enregistrement et plan d'actions{' '}
                                            <span className="font-semibold text-gray-700 dark:text-neutral-300">
                                                {cycleLang.nom_cycle_lang}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default FormulairesPlanaction
